import { Link, navigate } from "@reach/router";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import simboloBlanco from "../assets/rebrand/simbolo-blanco.png";


const Loading = () => {
  const [prev, setPrev] = useState(false);
  const { spinner, signOut } = useContext(AuthContext);

  useEffect(() => {
    setPrev(spinner);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!spinner && prev) {
      navigate("/entrar");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spinner]);

  return (
    <div className="container-fluid vh-100">
      <div id="loading"></div>
      <div className="row">
        <div className="overlay vh-100"></div>
      </div>
      <div className="row align-items-center pb-5 vh-100 text-white btn-container">
        <div className="container-fluid loading-text text-center">
          <img alt="cargando..." src={simboloBlanco} className="loading-logo mb-5" />
          <h4 className="text-white">Accediendo</h4>
          <div className="spinner-border text-white mb-3"></div>
          <p className="mb-0 text-white">
            Si la página no carga en más de 30 segundos es porque tu sesión ha
            expirado.
          </p>
          <Link to="/entrar" className="text-white" onClick={signOut}>
            Haz click aquí para Iniciar Sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Loading;
